export default __webpack_public_path__ + "static/media/damodra-bg.441d47f0.png";